import React, { useCallback } from "react";
import JupyterNotebook from "./JupyterNooteBook";
import { MODIFY_RUNNING_CODE_OUTPUT } from "../WorkflowContext/reducer";
import { useWorkflowContext } from "../WorkflowContext/WorkflowContext";
const NotebookWithRun = (props) => {
    const { state, dispatch, RunCodeCells, StopCodeExecution } = useWorkflowContext();
    // console.log(state);
    const RunCodeCell1 = React.useCallback((cellIndex, code) => {
        RunCodeCells(cellIndex, code);
    }, [])
    const StopExecution = useCallback(() => {
        StopCodeExecution();
    }, [])
    return (
        <>
            <JupyterNotebook
                Display_code_cells={props.Display_code_cells}
                Display_output_cells={props.Display_output_cells}
                RunCodeCell={RunCodeCell1}
                StopExecution={StopExecution}
                hideOutputBlocks={props.hideOutputBlocks}
                hideCodeBlocks={props.hideCodeBlocks}
            />
        </>
    )
}

export default NotebookWithRun;